import styles from './Divider.scss'

const Divider = () => <div class={styles.divider} />

export default Divider



// WEBPACK FOOTER //
// ./components/Divider/Divider.js